<template>
  <v-container class="accordion-container pl-0 pr-0">
    <v-expansion-panels class="accordion">
      <v-expansion-panel
        v-for="(item, index) in accordionData"
        :class="{ 'nav-drawer-accordion': isNavDrawer }"
      >
        <v-expansion-panel-header
          v-if="html"
          :key="index"
          class="accordion-header"
        >
          <div v-html="item.title"></div>
        </v-expansion-panel-header>
        <v-expansion-panel-header v-else class="accordion-header">
          {{ item.title }}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="accordion-content">
          <div
            v-if="html"
            v-html="item.content"
            class="panel-inner-content"
          ></div>
          <div v-else class="panel-inner-content">
            {{ item.content }}
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    html: {
      required: false,
      default: false,
      type: Boolean,
    },
    accordionData: {
      required: false,
      default: () => [],
      type: Array,
    },
    isNavDrawer: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss">
.accordion-container {
  max-width: 766px;
  padding-top: 0;
  padding-bottom: 40px;

  .nav-drawer-accordion {
    padding: 12px !important;
  }

  .accordion {
    .v-expansion-panel--next-active,
    .v-expansion-panel-header--active {
      border-bottom: 1px solid #e0e0e0 !important;
    }
    .v-expansion-panel-content__wrap {
      padding: 25px 33px;
    }
    .v-expansion-panel-header__icon {
      .v-icon {
        color: #282828 !important;
      }
    }
    .v-expansion-panel,
    .v-expansion-panel-header,
    .v-expansion-panel-content {
      margin: 0;

      .accordion-header {
        min-height: 70px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        h2 {
          font-size: 16px;
          font-weight: 700;
          line-height: 22px;
          text-align: left;
          color: #282828;
          padding-right: 24px;
        }
      }
      .accordion-content {
        background-color: #f9f9f9;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0.25px;
        color: #747474;
        .panel-inner-content {
          p {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0.25px;
            text-align: left;
          }
          h2 {
            margin-bottom: 11px;
            font-size: 16px;
            font-weight: 600;
          }
          li {
            margin-bottom: 1em;
          }
          .accordion-image {
            width: 100%;
            margin: 12px 0;
          }
        }
      }
    }

    .v-expansion-panel-content {
      transition: max-height 5s ease, opacity 5s ease;
      overflow: hidden;
    }
  }
}

.custom-expansion-panel {
  border-bottom: 1px solid #e0e0e0;
}

.custom-expansion-panel
  .custom-expansion-panel
  .v-expansion-panel-content__wrap {
  border-top: 1px solid #e0e0e0;
}
</style>
